import openaiIcon from "../../../assets/images/providers/openai.svg";
import geminiIcon from "../../../assets/images/providers/gemini.svg";
import claudeIcon from "../../../assets/images/providers/claude.svg";

export const PROVIDER_ICON_SRC = {
	openai: openaiIcon,
	gemini: geminiIcon,
	claude: claudeIcon,
};

export const PROVIDER_DISPLAY_LABELS = {
	openai: "ChatGPT",
	gemini: "Gemini",
	claude: "Claude",
	perplexity: "Perplexity",
};

export function normalizeProviderKey(provider) {
	const k = String(provider || "").toLowerCase().trim();
	if (!k) return "";
	if (k === "gpt" || k === "chatgpt" || k === "openai") return "openai";
	if (k === "gemini" || k.includes("google gemini")) return "gemini";
	if (k === "claude" || k.includes("anthropic")) return "claude";
	if (k === "perplexity") return "perplexity";
	return k;
}

export function providerDisplayLabel(provider) {
	const key = normalizeProviderKey(provider);
	return PROVIDER_DISPLAY_LABELS[key] || provider || "Engine";
}
